import React from "react";
import Body from "./Body";
import Ads from "../Ads/Ads";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

const AdsPage = () => {
  const { token } = useSelector((state) => state.users);

  if (!token) {
    return <Redirect to='/login' />;
  } else {
    return (
      <Body state={3}>
        <Ads />
      </Body>
    );
  }
};

export default AdsPage;
